import React from 'react'
import { useSelector } from 'react-redux'
import { getPulsaraCurrentSubStep } from '../../selectors'
import { IMPORT_SUB_STEP_IDS } from '../../constants'
import PulsaraAttachments from './PulsaraAttachments.component'
import PulsaraVitalsLabs from './VitalsLabs.component'
import './PulsaraImport.component.css'

const PulsaraImport: React.FC = () => {
  const currentSubStep = useSelector(getPulsaraCurrentSubStep)

  const renderImportSubStep = () => {
    switch (currentSubStep) {
      case IMPORT_SUB_STEP_IDS.VITALS_LABS:
        return <PulsaraVitalsLabs />
      case IMPORT_SUB_STEP_IDS.ATTACHMENTS:
        return <PulsaraAttachments />
      default:
        return null
    }
  }

  return <>{renderImportSubStep()}</>
}

export default PulsaraImport
